module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "illustrations"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/contents-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("COLOUR ILLUSTRATIONS")])]), _c('p', {
    staticClass: "list-item1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "label"
  })]), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig1",
      "id": "ci_fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  1.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sepoy of the Cuttack Legion, 1817.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig2",
      "id": "ci_fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capt J. B. Neufville, Commanding Officer, Assam Light Infantry, 1828–1830.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig3",
      "id": "ci_fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col Simon Fraser Hannay, Commanding Officer, Assam Light Infantry, 1839–1861.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig4",
      "id": "ci_fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uniform of the 42nd Gurkha Light Infantry, c. 1886.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig5",
      "id": "ci_fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Replica King’s Colour, 42nd Assam Regiment of Bengal Native Light Infantry.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ci_fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Replica Regimental Colour.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig7",
      "id": "ci_fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The tombstone of Maj H. W. Priestley at Shillong.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig8",
      "id": "ci_fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kamakhya Temple in Gauhati.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig9",
      "id": "ci_fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Officers’ Mess in Abbottabad, built in 1911.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig10",
      "id": "ci_fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of Sari Bair, 9 August, 1915; by Terence Cuneo.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig11",
      "id": "ci_fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ci_fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The medals of Col E. S. Phipson CIE DSO OStJ IMS and Sub-Maj Gambirsing Pun IOM MC OBI.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig12",
      "id": "ci_fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Field Marshal The Viscount Slim; by Margaret Lindsay Williams, 1953.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig13",
      "id": "ci_fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Michael Allmand VC, 3/6th Gurkha Rifles.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig13",
      "id": "ci_fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rifleman Tulbahadur Pun VC, 3/6th Gurkha Rifles.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig15",
      "id": "ci_fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The sword of General Tanaka, commander of the Japanese 33 Division, received by General Slim at the surrender of Rangoon.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "list-item1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('span', {
    staticClass: "label"
  })]), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig16",
      "id": "ci_fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of Medicina, 16 April, 1945; by Terence Cuneo.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig17",
      "id": "ci_fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capt I. N. A. Thomas 6 GR, with the 14/20th King’s Hussars in Iraq, 1991.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig18",
      "id": "ci_fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helicopter roping-down drills in Borneo, 1964.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig19",
      "id": "ci_fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ci_fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jungle range at Lundu, Borneo, 1964.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig20",
      "id": "ci_fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hon Lt (GCO) Bhirkaraj Gurung, late 6 GR, recruiting in Nepal. ("), _c('em', [_vm._v("Sandro Tucci")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig21",
      "id": "ci_fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maj Duncan Briggs and Cpl Rinchen Wangdi Lepcha, Annapurna South, 1976.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig22",
      "id": "ci_fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Dasain")]), _vm._v(" – Sacrifice of a buffalo in Brunei, October, 1993.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig23",
      "id": "ci_fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ci_fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The unbeaten 6 GR basketball team, 1985.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig24",
      "id": "ci_fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Public Duties in London.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig25",
      "id": "ci_fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patrolling the Hong Kong/China Border.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig26",
      "id": "ci_fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duties in Aid of the Civil Power.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig27",
      "id": "ci_fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jungle training in Brunei. ("), _c('em', [_vm._v("Sandro Tucci")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig28",
      "id": "ci_fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit to the Regiment in Brunei by HRH The Prince of Wales, February, 1984.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig29",
      "id": "ci_fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ci_fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit in Church Crookham by Her Majesty The Queen in February, 1989. ("), _c('em', [_vm._v("Rex Features")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig30",
      "id": "ci_fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hong Kong border fence by night. ("), _c('em', [_vm._v("Sandro Tucci")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig31",
      "id": "ci_fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 GR ‘Taras’.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig32",
      "id": "ci_fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175th Anniversary Ceremony at the Tower of London on 4 November, 1992. ("), _c('em', [_vm._v("P.J. Gates")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig33",
      "id": "ci_fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ci_fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pipes and Drums with the Bands, Trumpets and Bugles of the 14th/20th King’s Hussars and The Royal Green Jackets. ("), _c('em', [_vm._v("P.J. Gates")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig34",
      "id": "ci_fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘"), _c('em', [_vm._v("Johnny Gurkha")]), _vm._v("’; LCpl Dhanbahadur Thapa and Rifleman Balbahadur Gurung. ("), _c('em', [_vm._v("Sandro Tucci")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig35",
      "id": "ci_fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corporal Pimbahadur Gurung 6 GR, the first Gurkha pilot in the British Army.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig36",
      "id": "ci_fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Allmand VC Presentation Parade in Hong Kong on 22 July, 1991.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig37",
      "id": "ci_fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/28_epilogue#ci_fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Colonel of the Regiment passing the Victoria Cross to the Gurkha Major.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BLACK AND WHITE ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": ".6em",
      "margin-bottom": ".6em"
    }
  }, [_c('em', [_vm._v("Between pages 8 and 9")])])]), _c('p', {
    staticClass: "list-item1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('span', {
    staticClass: "label"
  })]), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig1",
      "id": "bw_fig1"
    }
  }, [_vm._v("  1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig1"
    }
  }, [_vm._v("“Bubble and Squeak”, 7-pound mountain guns issued in 1884.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig2",
      "id": "bw_fig2"
    }
  }, [_vm._v("  2.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig2"
    }
  }, [_vm._v("The Subedar Major (senior Viceroy-Commissioned Officer), 1890.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig3",
      "id": "bw_fig3"
    }
  }, [_vm._v("  3.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig3"
    }
  }, [_vm._v("The officers at Shillong, 1897.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig4",
      "id": "bw_fig4"
    }
  }, [_vm._v("  4.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig4"
    }
  }, [_vm._v("Silver centrepiece; a Rifleman of the 42nd Gurkha Rifles.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig5",
      "id": "bw_fig5"
    }
  }, [_vm._v("  5.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig5"
    }
  }, [_vm._v("The trenches of Gallipoli, 1915. ("), _c('em', [_vm._v("Imperial War Museum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig6",
      "id": "bw_fig6"
    }
  }, [_vm._v("  6.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig6"
    }
  }, [_vm._v("Capt C. J. L. Allanson, as Adjutant 1/6th Gurkha Rifles, 1904.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig7",
      "id": "bw_fig7"
    }
  }, [_vm._v("  7.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig7"
    }
  }, [_vm._v("Col E. S. Phipson CIE DSO OStJ IMS. ("), _c('em', [_vm._v("Courtesy of the Director, National Army Museum, London")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig8",
      "id": "bw_fig8"
    }
  }, [_vm._v("  8.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig8"
    }
  }, [_vm._v("The officers, 1/6th Gurkha Rifles in Gallipoli, 1915.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig9",
      "id": "bw_fig9"
    }
  }, [_vm._v("  9.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig9"
    }
  }, [_vm._v("“The Stone”, thought to be a doorpost lintel from the Temple of Diana.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig10",
      "id": "bw_fig10"
    }
  }, [_vm._v("10.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig10"
    }
  }, [_vm._v("2/6th marching north to the Battle of Khan Baghdadi, 22 March, 1918.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig11",
      "id": "bw_fig11"
    }
  }, [_vm._v("11.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig11"
    }
  }, [_vm._v("Officers of the 1st, 2nd and 3rd Battalions, 1920.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig12",
      "id": "bw_fig12"
    }
  }, [_vm._v("12.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig12"
    }
  }, [_vm._v("‘Christmas Day in the Workhouse’ – 1/6th Gurkha Rifles, 1923.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig13",
      "id": "bw_fig13"
    }
  }, [_vm._v("13.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig13"
    }
  }, [_vm._v("‘Kasam Khane’, 1930s. Recruits marching under the unfurled replica Colours.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig14",
      "id": "bw_fig14"
    }
  }, [_vm._v("14.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#bw_fig14"
    }
  }, [_vm._v("‘Kasam Khane’, 1990s. Recruits are sworn in on the boxed replicas.")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": ".6em",
      "margin-bottom": ".6em"
    }
  }, [_c('em', [_vm._v("Between pages 56 and 57")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig15",
      "id": "bw_fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naik (Corporal) in Battle Order, 1939.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig16",
      "id": "bw_fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operations on the North-West Frontier. Waziriatan, 1931.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig17",
      "id": "bw_fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The North-West Frontier of India.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig18",
      "id": "bw_fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Officers of the 1st Battalion at Malakand in September, 1939.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig19",
      "id": "bw_fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New equipment received in Burma: 3″ mortars.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig20",
      "id": "bw_fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tracked carriers.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig21",
      "id": "bw_fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bren Light Machine Gun, which replaced the Vickers-Berthier.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig22",
      "id": "bw_fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The jeep, “a war-winning invention if ever there was one”.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('p', {
    staticClass: "list-item1"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('span', {
    staticClass: "label"
  })]), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig23",
      "id": "bw_fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air resupply in the jungle.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig24",
      "id": "bw_fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4/6th crossing the Irrawaddy on 27 January, 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig25",
      "id": "bw_fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mandalay Hill, 8 March, 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig26",
      "id": "bw_fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British officers and Mess staff of the 3rd Battalion, Abbottabad, late 1940.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig27",
      "id": "bw_fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tulbahadur Pun VC at the Coronation Parade, 1953.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig28",
      "id": "bw_fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2/6th Gurkha Rifles, during the later stages of the war in Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig29",
      "id": "bw_fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The long years of waiting and training had ended.” Italy, 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig30",
      "id": "bw_fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 2nd Battalion, during the advance through Italy, 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig31",
      "id": "bw_fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#bw_fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col W. M. Amoore DSO and 2/6th officers in May, 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": ".6em",
      "margin-bottom": ".6em"
    }
  }, [_c('em', [_vm._v("Between pages 104 and 105")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig32",
      "id": "bw_fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Sir Gerald Templer congratulates Maj D. H. Houston MC and A Company 2/6th in Malaya, 1954.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig33",
      "id": "bw_fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Sir Walter Walker KCB CBE DSO and two Bars, Dato Seri Setia.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig34",
      "id": "bw_fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captured terrorist weapons and ammunition, Malayan Emergency.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig35",
      "id": "bw_fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Field Marshal Lord Harding, with the British Officers, 1st and 2nd Battalions at Ipoh, August, 1959.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig36",
      "id": "bw_fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1/6th deploying from Tidworth to Borneo, January, 1964.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig37",
      "id": "bw_fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col B. H. Hickey MC and Bar with officers of the 1st Battalion, Borneo.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig38",
      "id": "bw_fig38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Hearts and Minds’, Borneo – Maj P. B. H. Robeson, C Company and the 2/6th Assault Pioneer Platoon at Salilran.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig39",
      "id": "bw_fig39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wallace Memorial Trophy, awarded annually to the Champion Company.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig40",
      "id": "bw_fig40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col A. S. Harvey MC and Bar at Bario, Burnei.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig41",
      "id": "bw_fig41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col and Mrs R. C. Neath with CSgt Amerbahadur Pun MM and Bar and Sgt Bombahadur Gurung MM in Kuala Lumpur on 6 February, 1967.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig42",
      "id": "bw_fig42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Hawk’, worn on the right sleeve by all 6th Gurkhas.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig43",
      "id": "bw_fig43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capt (QGO) Amarbahadur Gurung with Lt Col Frazer and the 14th/20th Guidon Party in 1965.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('p', {
    staticClass: "list-item1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('span', {
    staticClass: "label"
  })]), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig44",
      "id": "bw_fig44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amalgamation Parade in Hong Kong on 14 June, 1969. Support Company marches past Lt Col R. N. P. Reynolds MBE.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig45",
      "id": "bw_fig45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Hearts and Minds’, Hong Kong – Lt (QGO) Purnabahadur Gurung, Support Company 2/6th, 1968.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig46",
      "id": "bw_fig46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Public Duties in London.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig47",
      "id": "bw_fig47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#bw_fig47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frontier operations in Hong Kong.")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": ".6em",
      "margin-bottom": ".6em"
    }
  }, [_c('em', [_vm._v("Between pages 152 and 153")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig48",
      "id": "bw_fig48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Field Marshal the Viscount Slim KG, the ‘Uncle Bill’ of XIVth Army in Burma.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig49",
      "id": "bw_fig49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capt W. J. Slim MC, as Adjutant of the 1st Battalion.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig50",
      "id": "bw_fig50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sgt Jaibahadur Gurung and Rfn Tulbahadur Pun, Support Company, 2/6th GR in Malaysia, 1968.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig51",
      "id": "bw_fig51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maj Gen. J. A. R. Robertson CB CBE DSO and Bar, Col N. F. B. Shaw DSO OBE and Brig W. C. Walker DSO and Bar OBE.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig52",
      "id": "bw_fig52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maj Gen A. G. Patterson DSO OBE MC in Kluang, West Malaysia, 1968.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig53",
      "id": "bw_fig53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bisley Queen’s Medallists: Lt (QGO) Dharmendra Gurung (1982 and 1993), WO 2 Khusiman Gurung (1985) and Rifleman Lalitbahadur Gurung (1992). ("), _c('em', [_vm._v("Soldier Magazine")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig54",
      "id": "bw_fig54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col C. J. L. Allanson DSO as CO-designate 2/6th,")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig55",
      "id": "bw_fig55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col P. D. Pettigrew with Maj Gen D. Boorman, the officers and their ladies in Brunei, 1983.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig56",
      "id": "bw_fig56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col R. F. Richardson-Aitken and Brig P. R. Duffell patrol the Hong Kong–China Border, 1985.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig57",
      "id": "bw_fig57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Service of Re-dedication of the Book of Remembrance by The Dean of Winchester on 8 November, 1988. ("), _c('em', [_vm._v("Hampshire Chronicle")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig58",
      "id": "bw_fig58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guest Night for past Colonels of the Regiment and former Commanding Officers of the 1st and 2nd Battalions in Church Crookham, 1989.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig59",
      "id": "bw_fig59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Her Majesty Thje Queen’s visit to Church Crookham on 5 May, 1978.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('p', {
    staticClass: "list-item1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('span', {
    staticClass: "label"
  })]), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig60",
      "id": "bw_fig60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Her Majesty The Queen inspecting the 6 GR Guard of Honour in Hong Kong on 21 October, 1986.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig61",
      "id": "bw_fig61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt Col N. A. Collett and the officers after the 175th Anniversary Parade in Brunei, 1992.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig62",
      "id": "bw_fig62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs Marie Pett, Mrs Sudha Rai and a group of Gurkha wives and children.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig63",
      "id": "bw_fig63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maj Harkasing Rai MC and Bar IDSM MM.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig64",
      "id": "bw_fig64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#bw_fig64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Almighty created in the Gurkha an ideal Infantryman” – 21164983 Rifleman Budhibahadur Gurung 6 GR.")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": ".6em",
      "margin-bottom": ".6em"
    }
  }, [_vm._v("In addition to the acknowledgments shown above, thanks are also due to the following for permission to reproduce photographs:")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The Trustees, 6th Queen Elizabeth’s Own Gurkha Rifles, Lt Col D. H. McK. Briggs, Lt Col N. A. Collett, Sgt D. Forsey RMP, Lt Col P. P. A. Gouldsbury, Maj P. Griffin MBE, Lt Col A. S. Harvey OBE MC, Lt Col R. C. Neath OBE, Maj Gen R. A. Pett MBE, Maj P. B. H. Robeson, Lt Col The Viscount Slim OBE, Capt I. N. A. Thomas, Lt Col M.J. R. Wardroper and Maj T. E. E. Whitehead.")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": ".6em"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#map1_1",
      "id": "map1_1"
    }
  }, [_vm._v("1.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#map1_1"
    }
  }, [_vm._v("North-East Indian and Northern Burma")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#map1_1"
    }
  }, [_vm._v("2.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#map1_1"
    }
  }, [_vm._v("North-West India")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#map2_1",
      "id": "map2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#map2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gallipoli Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#map2_2",
      "id": "map2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#map2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mesopotamia")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#map4_1",
      "id": "map4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#map4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burma")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#map5_1",
      "id": "map5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#map5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mogaung")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_chapter_6#map6_1",
      "id": "map6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter_6#map6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance to the Po Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#map7_1",
      "id": "map7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#map7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malaya")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#map8_1",
      "id": "map8_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#map8_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Borneo")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9acede6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/09_illustrations.vue
// module id = 78
// module chunks = 0